import React, { Component } from "react";
import ReactImageUploading from "react-images-uploading";
import Resizer from "react-image-file-resizer";

class ImageProvider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      images: [],
    };
  }
  dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }
  resizeImage(imageList) {
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        imageList[0].file,
        1500,
        1500,
        "JPEG",
        100,
        0,
        (uri) => {
          var file = this.dataURLtoFile(uri, "filename.JPEG");
          this.props.updateImages([{ data_url: uri, file: file }]);
        },
        "base64"
      );
    });
  }
  render() {
    return (
      <ReactImageUploading
        multiple={false}
        value={this.props.images}
        onChange={(imageList, addUpdateIndex) => this.resizeImage(imageList)}
        maxNumber={20}
        dataURLKey="data_url"
      >
        {({
          imageList,
          onImageUpload,
          onImageRemoveAll,
          onImageUpdate,
          onImageRemove,
          isDragging,
          dragProps,
        }) => (
          <section className="row mx-0 px-0">
            {this.props.isBtn ? (
              <div className="col-12 px-0">
                <button
                  className="btn rounded28 fw-bold py-2 w-100 bg-color-main text-white small"
                  onClick={onImageUpload}
                >
                  اپلود فیش واریز
                </button>
              </div>
            ) : (
              <div
                className="col-12 p-1"
                style={{ height: "100px" }}
                onClick={onImageUpload}
              >
                <div className="row mx-0 h-100 text-center bg-light-gray rounded14">
                  <div className="col px-0 align-self-center">
                    <img
                      alt="camera"
                      className=""
                      src={require("../../assets/icons/camera.svg").default}
                    />
                  </div>
                </div>
              </div>
            )}
          </section>
        )}
      </ReactImageUploading>
    );
  }
}

export default ImageProvider;
